var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPilotStuntPilot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 280 280",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{isolation:isolate;}.cls-2{fill:#e2dbd3;}.cls-3{fill:#6982af;}.cls-4{fill:#4668a3;}.cls-5{fill:#7699c4;}.cls-6{fill:#bc5e5e;}.cls-7{fill:#fff;}.cls-8{fill:#fff5eb;}.cls-9{fill:#605d5a;}.cls-10{fill:#d392a7;}.cls-11{fill:#00f3ff;mix-blend-mode:hard-light;opacity:0.3;}.cls-12{fill:#7a94ce;}.cls-13{fill:#d0e3f7;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "119.25 87.69 111.35 89.88 94.33 55.3 67.2 -52.18 93.92 -91.86 119.25 87.69"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "161.21 87.41 169.11 89.6 186.13 55.02 213.26 -52.47 186.54 -92.14 161.21 87.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "59.41 288.74 71.27 242.28 140.8 205.78 208.96 241.31 222.96 288.74 59.41 288.74"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "181.06 226.5 209.33 241.72 211.33 248.72 185.06 242.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "182.67 288.74 99.7 288.74 111.56 216.44 170.81 216.44 182.67 288.74"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "99.27 227.28 71 242.5 69 249.5 95.26 242.96"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "156.59 242.52 168.44 250.59 177.28 288.74 157.78 288.74 155.41 267.41 156.59 242.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "84.3 211.7 109.19 220.75 176.74 219.38 195.66 206.96 200.44 231.85 192.15 248.44 141.19 256.74 90.22 248.44 80.61 231.85 84.3 211.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "189.78 217.63 140 228.3 92.59 217.63 91.41 206.96 189.78 206.96 189.78 217.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "192.15 210.52 140 222.37 87.85 210.52 72.44 159.56 96.15 84.89 140 73.04 183.85 84.89 207.56 159.56 192.15 210.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "146.75 209.33 135.56 209.33 130.54 201.66 151.77 201.66 146.75 209.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "140.63 202.94 130.14 207.59 107.63 198.23 104.04 178.29 127.23 160.85 140.63 165.4 153.25 160.35 177.23 178.29 173.39 198.48 151.91 207.59 140.63 202.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "118.77 163.44 109.87 162.65 107.94 146.37 114.33 140.28 121.09 157.4 118.77 163.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "161.71 162.56 170.61 161.77 172.54 145.5 166.15 139.41 159.39 156.52 161.71 162.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "142.89 196.12 138.38 196.12 129.36 187.09 141.39 185.59 151.91 187.09 142.89 196.12"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "150.67 87.26 140.59 89.63 130.52 87.26 128.15 76.59 140.59 73.04 153.04 76.59 150.67 87.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "79.56 -47.85 87.85 -57.33 108.22 55.85 105.63 62.37 79.56 -47.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "201.35 -47.85 193.06 -57.33 172.69 55.85 175.28 62.37 201.35 -47.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "190.96 166.67 140.63 174.96 90.22 166.67 90.22 125.19 140.8 113.33 190.96 125.19 190.96 166.67"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "195.82 87.17 141.14 72.39 86.46 87.17 56.91 181.27 83.54 221.12 106.67 226.04 91.36 169.27 99.66 125.19 141.14 116.89 182.62 125.19 190.92 169.27 175.62 226.04 198.75 221.12 225.38 181.27 195.82 87.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "86.46 87.17 56.91 181.27 67.02 134.15 64.57 99.13 86.46 87.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "195.78 87.65 225.33 181.75 215.22 134.63 217.67 99.6 195.78 87.65"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 195.28,
    y1: 88.06,
    x2: 140.6,
    y2: 73.28
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "150.88 98.72 140.8 101.09 130.73 98.72 128.36 71.46 140.8 67.91 153.25 71.46 150.88 98.72"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "126.64 242.52 114.79 250.59 105.95 288.74 125.45 288.74 127.83 267.41 126.64 242.52"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPilotStuntPilot);
export default __webpack_public_path__ + "static/media/pilot-stunt-pilot.8b0a3d105f7a549a87cb1726d3c7a0d2.svg";
export { ForwardRef as ReactComponent };